<script setup lang="ts">
import BackgroundIcon from '@/components/icons/backgrounds/BackgroundIcon.vue'
import { useEditorStore } from '@/stores/Editor'

const editorStore = useEditorStore()
</script>

<template>
  <section class="section public-join-greenspark">
    <BackgroundIcon
      class="background-icon background-icon--left"
      align="left"
      variant="filled"
      :icon-type="editorStore.editor.background.icon"
    />
    <v-container>
      <div class="wrapper">
        <h2>{{ $t('PublicJoinGreenspark.title') }}</h2>
        <GsButton
          href="https://www.getgreenspark.com/account-type"
          target="_blank"
          type="success"
          width="130"
        >
          {{ $t('PublicJoinGreenspark.button') }}
        </GsButton>
      </div>
    </v-container>
    <BackgroundIcon
      class="background-icon background-icon--right"
      align="right"
      variant="filled"
      :icon-type="editorStore.editor.background.icon"
    />
  </section>
</template>

<style lang="scss" scoped>
.section {
  display: flex;
  align-items: center;
  position: relative;

  @include media('md-and-up') {
    min-height: 305px;
  }

  :deep(.background-icon) {
    position: absolute;
    display: block;
    top: 50%;
    z-index: 0;
    width: 120px;
    height: 100px;
    transform: translateY(-50%);

    &.background-icon--left {
      left: -25px;
      transform: translateY(-50%) scaleY(-1);

      @include media('md-and-up') {
        width: 350px;
        height: 280px;
        left: -70px;
      }
    }

    &.background-icon--right {
      right: -15px;
      transform: translateY(-50%) rotate(35deg);

      @include media('md-and-up') {
        width: 350px;
        height: 280px;
        right: -50px;
      }
    }
  }
}

.wrapper {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-direction: column;
  justify-items: center;
  text-align: center;
  margin: 0 auto;
  max-width: 230px;

  @include media('md-and-up') {
    max-width: 100%;
    gap: 34px;
  }
}

h2 {
  color: var(--gray-light-f5);
  font-size: 24px;
  font-weight: 700;

  @include media('md-and-up') {
    font-size: 40px;
  }
}
</style>
